import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SUBMIT_FEES_EXEMPTION_ASYNC,
    Actions.SUBMIT_FEES_EXEMPTION_SUCCESS,
    Actions.SUBMIT_FEES_EXEMPTION_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.SUBMIT_FEES_EXEMPTION_ASYNC:
    case Actions.SUBMIT_FEES_EXEMPTION_SUCCESS:
    case Actions.SUBMIT_FEES_EXEMPTION_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }

    default:
      return state
  }
}
